// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1rOJl","footer":"ModalCreateQualiphyProcedure_footer__2gsiv","additionData":"ModalCreateQualiphyProcedure_additionData__3gBM6"};